module.exports = __webpack_public_path__ + "cd21514d0531fdffb22204e0ec5ed84a.svg";